"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrypto = function () {
    //ie 11.x uses msCrypto
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-explicit-any
    return (window.crypto || window.msCrypto);
};
exports.getCryptoSubtle = function () {
    var crypto = exports.getCrypto();
    //safari 10.x uses webkitSubtle
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-explicit-any
    return crypto.subtle || crypto.webkitSubtle;
};
exports.validateCrypto = function () {
    if (!exports.getCrypto()) {
        throw new Error('For security reasons, `window.crypto` is required to run `auth-spa-js`.');
    }
    if (typeof exports.getCryptoSubtle() === 'undefined') {
        throw new Error("\n      auth-spa-js must run on a secure origin.\n      See https://github.com/auth0/auth0-spa-js/blob/master/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin \n      for more information.\n    ");
    }
};
var decodeB64 = function (input) {
    return decodeURIComponent(atob(input)
        .split('')
        .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
};
exports.urlDecodeB64 = function (input) { return decodeB64(input.replace(/_/g, '/').replace(/-/g, '+')); };
exports.createRandomString = function () {
    var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.';
    var random = '';
    var randomValues = Array.from(exports.getCrypto().getRandomValues(new Uint8Array(43)));
    randomValues.forEach(function (v) { return (random += charset[v % charset.length]); });
    return random;
};
exports.createQueryParams = function (params) {
    return Object.keys(params)
        .filter(function (k) { return typeof params[k] !== 'undefined'; })
        .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); })
        .join('&');
};
function typedKeys(o) {
    // type cast should be safe because that's what really Object.keys() does
    return Object.keys(o);
}
exports.decode = function (token) {
    var parts = token.split('.');
    var header = parts[0], payload = parts[1], signature = parts[2];
    if (parts.length !== 3 || !header || !payload || !signature) {
        throw new Error('ID token could not be decoded');
    }
    var payloadJSON = JSON.parse(exports.urlDecodeB64(payload));
    var claims = { "https://uninow.com/jwt/claims": {}, __raw: token };
    typedKeys(payloadJSON).forEach(function (k) {
        var _a;
        claims = __assign(__assign({}, claims), (_a = {}, _a[k] = payloadJSON[k], _a));
    });
    return {
        encoded: { header: header, payload: payload, signature: signature },
        header: JSON.parse(exports.urlDecodeB64(header)),
        claims: claims
    };
};
var isNumber = function (n) { return typeof n === 'number'; };
exports.verify = function (options) {
    if (!options.idToken) {
        throw new Error('ID token is required but missing');
    }
    var decoded = exports.decode(options.idToken);
    if (!decoded.claims.iss) {
        throw new Error('Issuer (iss) claim must be a string present in the ID token');
    }
    if (decoded.claims.iss !== options.iss) {
        throw new Error("Issuer (iss) claim mismatch in the ID token; expected \"" + options.iss + "\", found \"" + decoded.claims.iss + "\"");
    }
    if (!decoded.claims.sub) {
        throw new Error('Subject (sub) claim must be a string present in the ID token');
    }
    if (decoded.header.alg !== 'RS256') {
        throw new Error("Signature algorithm of \"" + decoded.header.alg + "\" is not supported. Expected the ID token to be signed with \"RS256\".");
    }
    if (!decoded.claims.aud || !(typeof decoded.claims.aud === 'string' || Array.isArray(decoded.claims.aud))) {
        throw new Error('Audience (aud) claim must be a string or array of strings present in the ID token');
    }
    if (Array.isArray(decoded.claims.aud)) {
        if (!decoded.claims.aud.includes(options.aud)) {
            throw new Error("Audience (aud) claim mismatch in the ID token; expected \"" + options.aud + "\" but was not one of \"" + decoded.claims.aud.join(', ') + "\"");
        }
        if (decoded.claims.aud.length > 1) {
            if (!decoded.claims.azp) {
                throw new Error('Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values');
            }
            if (decoded.claims.azp !== options.aud) {
                throw new Error("Authorized Party (azp) claim mismatch in the ID token; expected \"" + options.aud + "\", found \"" + decoded.claims.azp + "\"");
            }
        }
    }
    else if (decoded.claims.aud !== options.aud) {
        throw new Error("Audience (aud) claim mismatch in the ID token; expected \"" + options.aud + "\" but found \"" + decoded.claims.aud + "\"");
    }
    if (options.nonce) {
        if (!decoded.claims.nonce) {
            throw new Error('Nonce (nonce) claim must be a string present in the ID token');
        }
        if (decoded.claims.nonce !== options.nonce) {
            throw new Error("Nonce (nonce) claim mismatch in the ID token; expected \"" + options.nonce + "\", found \"" + decoded.claims.nonce + "\"");
        }
    }
    /* istanbul ignore next */
    if (!isNumber(decoded.claims.exp)) {
        throw new Error('Expiration Time (exp) claim must be a number present in the ID token');
    }
    if (!isNumber(decoded.claims.iat)) {
        throw new Error('Issued At (iat) claim must be a number present in the ID token');
    }
    var leeway = options.leeway || 60;
    var now = new Date();
    var expDate = new Date(0);
    expDate.setUTCSeconds((decoded.claims.exp || 0) + leeway);
    if (now > expDate) {
        throw new Error("Expiration Time (exp) claim error in the ID token; current time (" + now + ") is after expiration time (" + expDate + ")");
    }
    return decoded;
};
